module.exports = __webpack_public_path__ + "img/MEDIA084.e2614655.jpg";